module.exports = __webpack_public_path__ + "img/7.aa9e3370.jpeg";